import { Injectable } from '@angular/core';

import { Notification } from './notification';

@Injectable()
export class NotificationService {

	private notifier = new Notification();

	private notifier_options = {
		type: "success",
		timer: 1000,
		placement: {
			from: "top",
			align: "right"
		}
	};

	logged_notification = true;

	public danger(error, message) {
		this.notifier_options.type = "danger";
		if(error.code && (error.code != 401))
			this.notifier.notify(message + '<br><i>' + error.error._message + '</i>', this.notifier_options, "ti-alert");
		if(error.type && (error.type == "error"))
			this.notifier.notify("<b>Problème de communication avec le serveur!</b>", this.notifier_options, "ti-alert");
	}

	public success(message) {
		this.notifier_options.type = "success";
		this.notifier.notify(message, this.notifier_options);
	}

	public warning(message) {
		this.notifier_options.type = "warning";
		this.notifier.notify(message, this.notifier_options, "ti-alert");
	}

  public info(message) {
		this.notifier_options.type = "info";
		this.notifier.notify(message, this.notifier_options, "ti-info");
	}

}



// WEBPACK FOOTER //
// ./src/app/shared/notification/notification.service.ts